export const SDK_VERSION = '0.0.3'
